import React from 'react'
import PropTypes from 'prop-types'
import TooltipComponent from '../utils/TooltipComponent'
import IconComponent from './IconComponent'
import ButtonComponent from './ButtonComponent'

const SubmitButtonComponent = ({ buttonTitle, iconName, hidden, disabled }) => {
  return (
    <div className="pull-right">
      <TooltipComponent content={buttonTitle} id="submit-tooltip" placement="left">
        <ButtonComponent type="submit" color="primary mb-1" disabled={disabled} hidden={hidden}>
          <IconComponent icon={iconName} height="18" /> &nbsp;&nbsp;{buttonTitle}
        </ButtonComponent>
      </TooltipComponent>
    </div>
  )
}

SubmitButtonComponent.propTypes = {
  buttonTitle: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default SubmitButtonComponent
